export class JobLocation {
	constructor(public lat: number, public lng: number) {}
}
